import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import stksrt from './assets/stksrt.png'
import Three from './assets/inter.jpg'
import Med from './assets/med.jpg'
import Non from './assets/non.jpg'
import LRU from './assets/LRU.png'
import pf from './assets/pf.jpg'
import coil from './assets/coil.jpg'
import boggle from './assets/BOGGLE.jpg'
import lpp from './assets/lpp.png'
import Sc from './assets/Sc.jpeg'
import Rpn from './assets/Rpn.jpg'
import sad from './assets/sad.png'
import spltll from './assets/spltll.png'
import interleave from './assets/interleave.jpg'
import maxSum from './assets/maxSum.png'

const Ind = () => {
    return (
        <div>
          <h1 style={{textAlign:'centre'}}>Yahoo Interview question</h1>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Non}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>First non-repeating character in a stream</p>
      <NavLink to='/category/Yahoo Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Med} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Find median in a stream</p>
      <NavLink to='/category/Yahoo Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={pf} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Largest prime factor</p>
        <NavLink to='/category/Yahoo Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={coil} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Form coils in a matrix</p>
      <NavLink to='/category/Yahoo Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={boggle} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Word Boggle</p>
      <NavLink to='/category/Yahoo Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={lpp} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Largest Product Palindrome</p>
      <NavLink to='/category/Yahoo Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Sc} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Surpasser Count</p>
        <NavLink to='/category/Yahoo Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Rpn} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Return two prime numbers</p>
      <NavLink to='/category/Yahoo Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={stksrt} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sort a stack</p>
      <NavLink to='/category/Yahoo Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={Three} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Three way partitioning</p>
      <NavLink to='/category/Yahoo Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={LRU} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>LRU Cache</p>
        <NavLink to='/category/Yahoo Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={sad} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Serialize and Deserialize a Binary Tree</p>
      <NavLink to='/category/Yahoo Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={spltll} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Split a Circular Linked List into two halves</p>
      <NavLink to='/category/Yahoo Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    
  
  <div class="card 3">
    <div class="card_image">
      <img src={interleave} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Interleaved Strings</p>
        <NavLink to='/category/Yahoo Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={maxSum} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Max Sum without Adjacents</p>
      <NavLink to='/category/Yahoo Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
  
    </div>
        </div>
    )
}

export default Ind
